import React from "react";

import { inject, observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo, faEdit, faDownload } from "@fortawesome/free-solid-svg-icons";

import { PermissionsController } from "../../PermissionsController";
import { Button, Select, Tooltip } from "antd";
import { getAvailablePermissions } from "../../permissionsData";

const { Option } = Select;

@inject("permissionsController")
@observer
export class PermissionsHeader extends React.Component<{
  permissionsController?: PermissionsController;
}> {
  private showDebugMode = () => {
    const { userRolesData, resyncRoles, resyncModeEnabled, jsonViewer } = this.props.permissionsController;

    if (resyncModeEnabled) {
      const hasInvalidData = userRolesData.some((ur) => ur.mismatchedData);

      return (
        <>
          <Tooltip placement="bottomLeft" title={"View Original User Routes Data"} arrowPointAtCenter={true} mouseEnterDelay={0} mouseLeaveDelay={0}>
            <Button style={{ marginLeft: 5 }} size="small" icon="profile" onClick={() => jsonViewer.loadModal("Original User Routes Data", getAvailablePermissions())} disabled={!hasInvalidData} />
          </Tooltip>
          <Tooltip placement="bottomLeft" title={hasInvalidData ? "Resync All Unmatched Data" : "All Roles Synched"} arrowPointAtCenter={true} mouseEnterDelay={0} mouseLeaveDelay={0}>
            <Button style={{ marginLeft: 5 }} size="small" icon={hasInvalidData ? "sync" : "check"} onClick={() => resyncRoles()} disabled={!hasInvalidData} />
          </Tooltip>
        </>
      );
    }

    return null;
  };

  private renderPageSelection = () => {
    const { permissionTypes } = this.props.permissionsController;

    const elements = [];

    permissionTypes.forEach((pt) => {
      elements.push(
        <Option value={pt.key} key={pt.key}>
          {pt.name}
        </Option>
      );
    });

    return elements;
  };

  private handlePermissionsPageChange = (key) => {
    const { permissionTypes, loadUserRolesData, resetRoleSelection } = this.props.permissionsController;

    const selectedPage = permissionTypes.find((pt) => pt.key === key);

    this.props.permissionsController.selectedPermissionType = selectedPage;

    resetRoleSelection();
    loadUserRolesData();
  };

  public render() {
    const { validation, exportRolePermissions, userRolesData, selectedPermissionType, enableResyncMode, fetchingRoles } = this.props.permissionsController;

    return (
      <>
        <div className="permissionsHeader" style={{ borderBottom: 0 }}>
          <Select
            style={{ flex: 1 }}
            placeholder={"Select Permission Page"}
            value={selectedPermissionType ? selectedPermissionType.key : undefined}
            onChange={this.handlePermissionsPageChange}
            disabled={true}
          >
            {this.renderPageSelection()}
          </Select>
          <Button
            style={{ marginLeft: 10 }}
            disabled={!validation("page") || fetchingRoles}
            icon={<FontAwesomeIcon icon={faRedo} />}
            onClick={() => this.handlePermissionsPageChange(selectedPermissionType.key)}
          />
        </div>
        <div className="permissionsHeader" style={{ paddingTop: 0 }}>
          <b className="flex-1" onDoubleClick={() => enableResyncMode()}>
            <span className="cursor-pointer">User Roles ({userRolesData.length})</span>
          </b>

          {this.showDebugMode()}

          {/* <Button
            style={{ marginLeft: 5 }}
            size="small"
            icon={<FontAwesomeIcon icon={faEdit} />}
            disabled={!validation("page")}
            onClick={() => (this.props.permissionsController.showBulkEditModal = true)}
          >
            Bulk Edit
          </Button>

          <Tooltip placement="bottomLeft" title="Export all roles" arrowPointAtCenter={true} mouseEnterDelay={0} mouseLeaveDelay={0}>
            <Button
              style={{ marginLeft: 5 }}
              size="small"
              icon={<FontAwesomeIcon icon={faDownload} />}
              disabled={!validation("page")}
              onClick={() => exportRolePermissions(userRolesData, "Exported Roles", true)}
            />
          </Tooltip> */}
        </div>
      </>
    );
  }
}
